// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"254":"f9824917","719":"f9824917"}[chunkId] + ".css";
};